import "./card.scss";
import { useState } from "react";
import Modal from "../modal/Modal";

const Card = ({ item }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="card">
      <div
        className="cardContainer"
        onClick={() => {
          setOpenModal(true);
        }}
      >
        {/* <img
          className="cardImage"
          src={item.img}
          alt={item.name}
        /> */}
        <div className="details"> 
          <div className="detailsLeft">
            <p className="title">{item.name}</p>
            <p className="ingredients">{item.ingredients.join(", ")}</p>
          </div>
          <div className="detailsRight">
            <p className="price">{item.name === "napoje" ? item.price[1] : item.price[0]}zł</p>
          </div>
        </div>
      </div>
      {openModal && (
        <Modal item={item} closeModal={setOpenModal} key={item._id} />
      )}
    </div>
  );
};

export default Card;
